module.exports = __webpack_public_path__ + "static/world-map-c08bf0171e65cad90995f494cd0d6545.png";